import React from 'react';
import FieldsManagement from '../../components/Admin/Fields/Fields';
const Fields = () => {
  return <FieldsManagement />;
};

export default Fields;
